import React from 'react';
import { CONSENT_TEXT } from './model';

export const Consent = ({ checked, onChange, error, disabled }) => <div className="booking-consent-wrap">
  <label className="booking-consent" htmlFor="booking-consent-input" data-testid="booking-consent-label">
    <input type="checkbox" id="booking-consent-input" data-testid="booking-consent" checked={checked} disabled={disabled} onChange={(event) => onChange(event.target.checked)} aria-invalid={Boolean(error)} aria-describedby={error ? 'booking-consent-error' : undefined} />
    <span>{CONSENT_TEXT}</span>
  </label>
  {error && <p className="sim-error" role="alert" id="booking-consent-error" data-testid="booking-consent-error">{error}</p>}
</div>;